import { render, staticRenderFns } from "./SubscriptionBuyers.vue?vue&type=template&id=88ed3528"
import script from "./SubscriptionBuyers.vue?vue&type=script&lang=js"
export * from "./SubscriptionBuyers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports